/**
 * Read a cookie by name (browser document.cookie).
 */
export function getCookie(name: string): string | null {
  const match = new RegExp(`(?:^|; )${name.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&')}=([^;]*)`).exec(document.cookie);

  return match ? decodeURIComponent(match[1]) : null;
}
